<template>
  <div class="navigation-panel h-full">
    <!-- 系列设置 -->
    <div class="nav-section">
      <div
        class="nav-item p-3 cursor-pointer hover:bg-gray-50 transition-colors"
        :class="{ 'bg-blue-50 border-l-4 border-blue-500 text-blue-600': activeSection === 'campaign' }"
        @click="$emit('section-change', 'campaign')"
      >
        <div class="flex items-center">
          <i class="el-icon-setting mr-3 text-lg"></i>
          <span class="font-medium">系列设置</span>
        </div>
      </div>

      <!-- 广告组列表 -->
      <div class="nav-subsection">
        <div class="nav-subsection-header p-3 bg-gray-50 text-sm text-gray-600 flex items-center justify-between">
          <span class="font-medium">广告组</span>
          <span class="bg-purple-100 text-purple-600 px-2 py-1 rounded-full text-xs font-medium">
            {{ data.adGroups ? data.adGroups.length : 0 }}
          </span>
        </div>

        <div
          v-for="(adGroup, index) in data.adGroups"
          :key="index"
          class="nav-adgroup-item"
        >
          <!-- 广告组项 -->
          <div
            class="nav-item pl-6 pr-3 py-3 cursor-pointer hover:bg-gray-50 border-l-2 border-transparent transition-all"
            :class="{
              'bg-purple-50 border-l-2 border-purple-500 text-purple-600': activeSection === `adGroup-${index}`,
            }"
            @click="$emit('section-change', `adGroup-${index}`)"
          >
            <div class="flex items-center justify-between">
              <div class="flex items-center flex-1 min-w-0">
                <span
                  class="w-6 h-6 rounded-full bg-purple-500 text-white text-xs flex items-center justify-center mr-3 font-medium flex-shrink-0"
                >
                  {{ index + 1 }}
                </span>
                <span class="text-sm font-medium break-words">{{ adGroup.name || `PH_未知MIF_${index + 18}` }}</span>
              </div>
              <div class="flex items-center space-x-2 flex-shrink-0 ml-2">
                <span class="text-xs text-gray-400">{{ adGroup.ads ? adGroup.ads.length : 0 }}</span>
                <i class="el-icon-right text-xs text-gray-400"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationPanel',
  props: {
    data: {
      type: Object,
      default: () => ({
        name: '',
        adGroups: [],
      }),
    },
    activeSection: {
      type: String,
      default: 'campaign',
    },
  },
};
</script>

<style lang="scss" scoped>
.navigation-panel {
  background: white;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.nav-item {
  transition: all 0.2s ease;
}

.nav-subsection-header {
  font-weight: 500;
}
</style>
